import { TextField, TextFieldProps } from "@mui/material";
import { forwardRef } from "react";

export const MuiInput = forwardRef<HTMLDivElement, TextFieldProps>(
  (props, ref) => {
    return (
      <TextField
        {...props}
        ref={ref}
        variant="outlined"
        fullWidth
        sx={{
          "& .MuiOutlinedInput-root": {
            backgroundColor: "var(--input-background-color, #FFFFFF)",
            color: "var(--input-text-color, #000000)",
            borderRadius: 0,
            fontFamily: "Montserrat, sans-serif",
            fontSize: "14px",
            minHeight: 66,
            display: "flex",
            alignItems: "center",

            "& fieldset": {
              borderColor: "var(--input-border-color, #cccccc)",
            },

            "&:hover fieldset": {
              borderColor: "var(--input-focus-border-color, #666666)",
            },

            "&.Mui-focused fieldset": {
              borderColor: "var(--input-focus-border-color, #666666)",
              borderWidth: "1px",
            },

            "& input": {
              fontFamily: "Montserrat, sans-serif",
              height: "100%",
              boxSizing: "border-box",
              padding: "0 14px",

              "&::placeholder": {
                color: "var(--input-placeholder-color, #8C8C8C)",
                opacity: 1,
                fontFamily: "Montserrat, sans-serif",
              },
            },
          },

          "& .MuiInputLabel-root": {
            fontFamily: "Montserrat, sans-serif",
          },

          ...props.sx,
        }}
      />
    );
  },
);

MuiInput.displayName = "MuiInput";
